import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const AdminPanel = () => {
  return (
    <>
      <Navbar />
      <div className="admin-panel-container">
        <h1>Admin Panel</h1>
        <p>This is a placeholder for the admin panel that would allow site administrators to manage content and users.</p>
      </div>
      <Footer />
    </>
  );
};

export default AdminPanel; 